import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';
import { type IComponentSchema } from '../../types';
import LinkComponent, { type ILinkProps } from '../link';

const FormLink = observer(
  ({ schema }: { schema: IComponentSchema<ILinkProps> }) => {
    const field = useField<VoidField>();

    const componentProps = {
      ...(schema?.['x-component-props'] || {}),
      ...(field?.componentProps || {}),
    } as ILinkProps;

    return (
      <LinkComponent
        schema={{ ...schema, 'x-component-props': componentProps }}
      />
    );
  }
);

export default FormLink;
